<template>
  <v-dialog class="dialog" v-model="requestResponseVisible" persistent @click:outside="close" max-width="400">
    <v-row class="pb-1" justify="space-between" no-gutters>
      <span class="txt-request-title">{{ $t('requestResponse') }}</span>
      <!-- <v-btn icon @click="close">
        <v-icon color="white">mdi-close</v-icon>
      </v-btn> -->
    </v-row>
    <!-- Member Select -->
    <v-container v-if="dialogState === DialogState.SelectUser" class="pa-0">
      <v-row class="mb-4" no-gutters>
        <span class="txt-request-sub-title">{{ $t('requestSubTitle') }}</span>
      </v-row>
      <v-row class="container-user-list" no-gutters justify="center">
        <v-col>
          <v-card max-width="400" elevation="0" dark>
            <v-list class="pt-0" color="#21343b">
              <v-list-item-group color="#3ed297">
                <v-list-item class="px-1" v-for="member in memberData" :key="member.userId" @click="select(member)">
                  <v-list-item-icon>
                    <attendee
                      :mtOrganizerUid="mtInfo.mtOrganizerUid"
                      :list="[member]"
                      :isAdd="false"
                      size="30"
                      :deleteOrgarnizer="false"
                    ></attendee>
                  </v-list-item-icon>

                  <v-list-item-content>
                    <v-list-item-title class="dialog-user-name">
                      {{ member.userDisplayName || member.userFullName }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-card>
          <v-progress-circular
            v-if="isLoading"
            color="primary"
            :width="3"
            size="50"
            style="margin-left: 150px; margin-top: 80px"
            indeterminate
          ></v-progress-circular>
        </v-col>
      </v-row>
      <v-row class="container-find-user my-5" no-gutters>
        <el-input placeholder="Find User" v-model="keyword" @keyup.native="querySearch" type="text" />
      </v-row>
    </v-container>
    <!-- Input Content -->
    <v-container v-else-if="dialogState === DialogState.InputContent" class="pa-0">
      <v-row class="mt-4 mb-2" no-gutters>
        <span class="txt-request-content-title">{{ $t('recipient') }}</span>
      </v-row>
      <v-row class="container-content pa-2" align="center" style="cursor: pointer" @click="selectRecipient" no-gutters>
        <v-col cols="auto">
          <attendee
            :mtOrganizerUid="mtInfo.mtOrganizerUid"
            :list="[selectMember]"
            :isAdd="false"
            size="30"
            :deleteOrgarnizer="false"
          ></attendee>
        </v-col>
        <v-col>
          <span class="dialog-user-name ml-5">{{ selectMember.userDisplayName || selectMember.userFullName }}</span>
        </v-col>
      </v-row>
      <v-row class="mt-4 mb-2" no-gutters>
        <span class="txt-request-content-title">{{ $t('requestContentTitle') }}</span>
      </v-row>
      <v-row class="container-content pa-1 px-2" no-gutters>
        <v-text-field
          dense
          color="tranparent"
          filled
          rounded
          dark
          :placeholder="$t('enterTopicHint')"
          hide-details="auto"
          v-model="clipTitle"
          :autofocus="clipTitle ? true : false"
        />
      </v-row>
      <v-row class="mt-4 mb-2" no-gutters>
        <span class="txt-request-content-title">{{ $t('dueDate') }}</span>
      </v-row>
      <v-row class="date_ex_col pa-1 mt-2 mb-2" style="cursor: pointer" @click="openDialog" no-gutters>
        <v-col align="center">
          <span class="dialog-user-name ml-2">{{ txtDate }}</span>
        </v-col>
      </v-row>
    </v-container>

    <v-row class="btn-bottom mt-8" justify="space-between" no-gutters>
      <v-col>
        <v-btn block height="40" elevation="0" color="#869399" @click="close">{{ $t('deleteCancel') }}</v-btn>
      </v-col>
      <v-col class="ml-4">
        <v-btn
          v-if="dialogState === DialogState.SelectUser"
          block
          height="40"
          elevation="0"
          :disabled="!isRequestAvailable"
          color="#3ed297"
          @click="onNext"
        >
          {{ $t('next') }}
        </v-btn>
        <v-btn
          v-else-if="dialogState === DialogState.InputContent"
          block
          height="40"
          elevation="0"
          color="#3ed297"
          :loading="isDoneLoading"
          @click="setCreateFollowUp"
        >
          {{ $t('done') }}
        </v-btn>
      </v-col>
    </v-row>
    <due-date-dialog
      v-if="datePickVisible"
      :dateVisible.sync="datePickVisible"
      @close="closeDate"
      @setSelectDate="setSelectDate($event)"
    ></due-date-dialog>
  </v-dialog>
</template>

<script>
import { getTargetList } from '@/services/meetingApi'
import DueDateDialog from '@/views/modal/DueDateDialog'
import { setCreateFollowUp } from '@/services/clipApi'
import Toast from '@/views/meeting/component/Toast'
import Attendee from '@/views/meeting/component/card/Attendee'
import { mapGetters } from 'vuex'

const DialogState = Object.freeze({
  SelectUser: 'selectUser',
  InputContent: 'inputContent',
})

export default {
  name: 'RequestResponseDialog',
  components: { DueDateDialog, Attendee },
  created() {
    this.getMember()
  },
  props: ['requestResponseVisible'],
  data() {
    return {
      memberList: [],
      memberData: [],
      keyword: '',
      selectMember: null,
      datePickVisible: false,
      isLoading: false,
      DialogState,
      dialogState: DialogState.SelectUser,
      clipTitle: null,
      selectDate: null,
      displayDate: null,
      isDoneLoading: false,
    }
  },
  methods: {
    setSelectDate(value) {
      this.selectDate = value.selectedDate
      this.displayDate = value.displayDate
      this.closeDate()
    },
    async getMember() {
      this.isLoading = true
      try {
        let ctx = this
        let userInfo

        let result = await getTargetList(this, this.mtInfo.mtId, this.userInfo.userId, false)
        this.memberList = result.mtTargetList
        if (this.memberList && this.memberList !== null) {
          userInfo = this.memberList.find((user) => user.userId === ctx.mtInfo.mtOrganizerUid)
          if (userInfo && userInfo !== null) this.memberList.splice(this.memberList.indexOf(userInfo), 1)
          this.memberList.unshift(userInfo)
        }
        this.setList()
      } catch (err) {
        console.log(err)
      } finally {
        this.isLoading = false
      }
    },
    setList() {
      this.memberData = []
      this.memberList.forEach((value, i) => {
        const member = {}
        member.index = i
        member.value = value.userDisplayName
        member.userId = value.userId
        member.userDisplayName = value.userDisplayName
        member.userFullName = value.userFullName
        member.userPicture = value.userPicture
        if (this.userInfo.userId !== member.userId) {
          this.memberData.push(member)
        }
      })
    },
    onNext() {
      if (this.dialogState === DialogState.SelectUser) this.dialogState = DialogState.InputContent
    },
    selectRecipient() {
      this.selectMember = null
      this.dialogState = DialogState.SelectUser
    },
    openDialog() {
      if (this.isRequestAvailable) this.datePickVisible = true
    },
    async setCreateFollowUp() {
      this.isDoneLoading = true
      try {
        let result = await setCreateFollowUp(
          this,
          this.mtInfo.wsId,
          this.mtInfo.mtId,
          this.stId,
          this.selectMember.userId === this.userInfo.userId ? 'willFollowUp' : 'followUp',
          this.clipTitle,
          this.selectDate,
          this.displayDate,
          this.selectMember.userId,
          this.chkMtPublic && this.chkMtPublic['isPublic']
        )

        // 전체 로딩을 없애주기 위해 sectionInfo를 받아오는 작업 추가
        this.$store.dispatch('setUploadClip', result)
        localStorage.setItem('currentClip', JSON.stringify(result))

        this.$store.dispatch('getAssignedCnt', this.wsInfo['wsId'])
        this.$store.dispatch('getChannelUpdate', {
          wsId: this.wsInfo['wsId'],
          chId: this.selectedCh['chId'].includes('CH:') ? this.selectedCh['chId'] : `CH:${this.selectedCh['chId']}`,
          chType: this.selectedCh['chType'],
          chCategory: this.selectedCh['chCategory'],
        })
      } catch (error) {
        if (error.response !== undefined && error.response.data === 'ExistFollowUp') {
          // notify(this, 'Error', this.$t('general.error'), 'error')
          const content = {
            component: Toast,
            props: {
              msg: this.$t('general.error'),
              // submsg: '',
            },
          }
          this.$toast.error(content)
        }
      } finally {
        this.isDoneLoading = false
        this.$emit('finish')
      }
    },
    querySearch() {
      this.setList()
      let links = this.memberData
      this.memberData = this.keyword ? links.filter(this.createFilter(this.keyword)) : links
    },
    createFilter(queryString) {
      return (link) => {
        return link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
      }
    },
    select(member) {
      this.selectMember = this.selectMember === member ? null : member
    },
    closeDate() {
      this.datePickVisible = false
    },
    finish() {
      this.closeDate()
      this.$emit('finish')
    },
    close() {
      let val = {}
      val.type = 'Request'
      this.$emit('close', val)
    },
  },
  computed: {
    ...mapGetters(['chkMtPublic', 'userInfo']),
    // mtTargetList() {
    //   return this.mtInfo && this.mtInfo.mtTargetList ? this.mtInfo.mtTargetList : []
    // },
    isRequestAvailable() {
      return this.selectMember && this.selectMember !== null
    },
    mtInfo() {
      return this.$store.getters.currentMt
    },
    wsInfo() {
      return this.$store.getters.selectedWsInfo
    },
    txtDate() {
      return this.displayDate && this.displayDate !== null ? this.displayDate : this.$t('selectDateHint')
    },
    totalSectionList() {
      return this.$store.getters.totalSectionList && this.$store.getters.totalSectionList !== null
        ? this.$store.getters.totalSectionList
        : []
    },
    sectionIndex() {
      return this.$store.getters.sectionIndex && this.$store.getters.sectionIndex !== null
        ? this.$store.getters.sectionIndex
        : 0
    },
    stId() {
      let stId
      if (this.totalSectionList.length > 0) stId = this.totalSectionList[this.sectionIndex].stId
      return stId
    },
  },
}
</script>

<style scoped>
.txt-request-title {
  font-weight: 700;
  font-size: 18px;
  color: white;
  align-self: center;
}
.txt-request-sub-title {
  font-weight: 400;
  font-size: 12px;
  color: #96a7af;
  text-align: left;
  /* align-self: left; */
}
.txt-request-content-title {
  font-weight: 700;
  font-size: 14px;
  color: white;
  align-self: center;
}
.v-dialog__content >>> .v-dialog {
  background: #21343b !important;
  /* border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px; */
  border-radius: 10px;
  padding: 30px;
}
.container-user-list {
  overflow-y: auto;
  overflow-x: hidden;
  height: 250px;
}
.dialog-user-name {
  font-weight: 600;
  font-size: 12px;
  line-height: 35px;
  color: white;
  padding: 0px;
}

.container-find-user >>> .el-input__inner {
  border: none !important;
  background-color: #1a272e !important;
  color: white;
}
.container-content {
  background-color: #1a272e !important;
  border-radius: 10px;
}

.crown {
  color: #ffc542;
  font-size: 15px;
  position: absolute;
  transform: translate(6px, -11px);
}
.selected-crown {
  color: #ffc542;
  font-size: 15px;
  position: absolute;
  transform: translate(-26px, -9px);
}

.btn-bottom >>> .v-btn * {
  font-size: 14px;
  color: white;
  letter-spacing: 0;
  text-transform: none;
  font-weight: bold;
}
.container-content >>> .v-input__slot {
  background: transparent !important;
  padding: 4px !important;
}
.container-content >>> input::placeholder {
  font-weight: 500;
  font-size: 14px !important;
}
.container-content >>> input {
  padding-top: 0px;
  font-weight: 500;
  font-size: 14px !important;
}

.date_ex_col {
  background-color: #31434f;
  border-radius: 5px !important;
}
.v-btn.v-btn--disabled.v-btn--has-bg {
  color: #fff !important;
  background-color: #869399 !important;
}
</style>
